"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var styles = require("./index.scss");
var prm_1 = require("utils/prm");
var ProductCardLT_1 = require("../ProductCardLT");
var Arrow_1 = require("./Arrow");
var _animationDuration = 1000;
var DoubleSwipe = (function (_super) {
    __extends(DoubleSwipe, _super);
    function DoubleSwipe() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.canClick = true;
        _this.autoSwipe = false;
        _this.countDown = 0;
        _this.state = {
            cIndex: 0,
            animationDuration: 0,
            aniIndex: 1,
            step: Math.max(_this.props.layout.columnNum, 4) * Math.max(_this.props.layout.rowNum, 1)
        };
        _this.onBack = function () {
            var _a = _this.state, cIndex = _a.cIndex, step = _a.step;
            var products = _this.props.products;
            if (!_this.canClick) {
                return;
            }
            _this.canClick = false;
            _this.setState({
                aniIndex: 0,
                animationDuration: _animationDuration
            });
            setTimeout(function () {
                var newCIndex = cIndex - step;
                _this.setState({
                    cIndex: newCIndex < 0 ? products.length + newCIndex : newCIndex,
                    animationDuration: 0,
                    aniIndex: 1
                });
                _this.canClick = true;
            }, _animationDuration);
        };
        _this.onNext = function () {
            var _a = _this.state, cIndex = _a.cIndex, step = _a.step;
            var products = _this.props.products;
            if (!_this.canClick || products.length <= step) {
                return;
            }
            _this.canClick = false;
            _this.setState({
                aniIndex: 2,
                animationDuration: _animationDuration
            });
            setTimeout(function () {
                var newCIndex = cIndex + step;
                _this.setState({
                    cIndex: newCIndex >= products.length ? newCIndex - products.length : newCIndex,
                    animationDuration: 0,
                    aniIndex: 1
                });
                _this.canClick = true;
            }, _animationDuration);
        };
        _this.getDoubleStyle = function () {
            var _a = _this.state, aniIndex = _a.aniIndex, animationDuration = _a.animationDuration;
            var style = {};
            style.width = "300%";
            var wrapperOffsetLeft = -1200 * aniIndex;
            style.transform = "translate3d(" + wrapperOffsetLeft + "px,0,0)";
            style.transitionDuration = animationDuration + "ms";
            style.WebkitTransform = style.transform;
            style.transitionTimingFunction = "ease-out";
            return style;
        };
        _this.renderCard = function (product, index) {
            var _a = _this.props, layout = _a.layout, customUI = _a.customUI, tprm = _a.tprm;
            var link = prm_1.genPrmLink(product.url, __assign({ position: index + 1 }, tprm));
            return (React.createElement(ProductCardLT_1.ProductCardLT, { key: index, product: __assign(__assign({}, product), { url: link }), shape: customUI ? customUI.shape : undefined, type: layout.columnNum === 5 ? "small" : "normal", layout: layout }));
        };
        _this.renderLeft = function () {
            var products = _this.props.products;
            var _a = _this.state, cIndex = _a.cIndex, step = _a.step;
            if (!cIndex) {
                return products.slice(-step).map(function (product, index) { return _this.renderCard(product, index); });
            }
            if (cIndex - step < 0) {
                return products
                    .slice(-(step - cIndex))
                    .concat(products.slice(0, cIndex))
                    .map(function (product, index) { return _this.renderCard(product, index); });
            }
            return products
                .slice(cIndex - step, cIndex)
                .map(function (product, index) { return _this.renderCard(product, index); });
        };
        _this.renderMiddle = function () {
            var products = _this.props.products;
            var _a = _this.state, cIndex = _a.cIndex, step = _a.step;
            if (cIndex + step > products.length) {
                return products
                    .slice(cIndex)
                    .concat(products.slice(0, cIndex + step - products.length))
                    .map(function (product, index) { return _this.renderCard(product, index); });
            }
            return products
                .slice(cIndex, cIndex + step)
                .map(function (product, index) { return _this.renderCard(product, index); });
        };
        _this.renderRight = function () {
            var products = _this.props.products;
            var _a = _this.state, cIndex = _a.cIndex, step = _a.step;
            if (cIndex + 16 <= products.length) {
                return products
                    .slice(cIndex + step, cIndex + step * 2)
                    .map(function (product, index) { return _this.renderCard(product, index); });
            }
            else if (cIndex + 16 > products.length && cIndex + step < products.length) {
                return products
                    .slice(cIndex + step)
                    .concat(products.slice(0, step - (products.length - (cIndex + step))))
                    .map(function (product, index) { return _this.renderCard(product, index); });
            }
            else if (cIndex + step > products.length && cIndex + step > products.length * 2) {
                return products
                    .slice(step - (products.length - cIndex))
                    .concat(products.slice(0, step - products.slice(step - (products.length - cIndex)).length))
                    .map(function (product, index) { return _this.renderCard(product, index); });
            }
            else {
                return products
                    .slice(step - (products.length - cIndex), step * 2 - (products.length - cIndex))
                    .map(function (product, index) { return _this.renderCard(product, index); });
            }
        };
        return _this;
    }
    DoubleSwipe.prototype.render = function () {
        var _this = this;
        var products = this.props.products;
        var step = this.state.step;
        if (products.length <= step) {
            return (React.createElement("div", { className: classnames_1.default(styles.eight) }, products.map(function (product, index) { return _this.renderCard(product, index); })));
        }
        return (React.createElement("div", { className: styles.doubleContainer, onMouseEnter: function () { return (_this.autoSwipe = false); }, onMouseLeave: function () { return (_this.autoSwipe = true); } },
            React.createElement(Arrow_1.Arrow, { type: Arrow_1.ArrowType.left, onClick: this.onBack }),
            React.createElement("div", { className: styles.scrollContainer, style: this.getDoubleStyle() },
                React.createElement("div", { className: styles.box },
                    React.createElement("div", { className: styles.inner }, this.renderLeft())),
                React.createElement("div", { className: styles.box },
                    React.createElement("div", { className: styles.inner }, this.renderMiddle())),
                React.createElement("div", { className: styles.box },
                    React.createElement("div", { className: styles.inner }, this.renderRight()))),
            React.createElement(Arrow_1.Arrow, { type: Arrow_1.ArrowType.right, onClick: this.onNext })));
    };
    return DoubleSwipe;
}(React.Component));
exports.default = DoubleSwipe;
